import { render, staticRenderFns } from "./SuorganizatorBase.vue?vue&type=template&id=54975327&scoped=true&"
import script from "./SuorganizatorBase.vue?vue&type=script&lang=js&"
export * from "./SuorganizatorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54975327",
  null
  
)

export default component.exports